import { element, showMessage } from '../components/publicUi.js';
import { getHomeContent } from '../services/api.js';
import { getLocale } from '../services/i18n.js';

const formatDate = value => value ? new Intl.DateTimeFormat(getLocale()).format(new Date(value)) : '';

export class HomePage {
  constructor(onNavigate) { this.onNavigate = onNavigate; }
  render() {
    const page = element('div', 'page-wrapper'), container = element('main', 'container home-content');
    const intro = element('header', 'home-intro');
    intro.append(element('p', 'home-kicker', '>_ fixlan.ru / latest'), element('h1', 'page-title', 'Исследования, инструменты и визуальные материалы'),
      element('p', 'page-desc', 'Новые публикации и материалы, отобранные для быстрого доступа.'));
    this.content = element('div', 'home-feed'); this.status = element('div', 'spec-box'); this.status.setAttribute('role', 'status');
    container.append(intro, this.status, this.content); page.append(container); void this.load(); return page;
  }
  async load() {
    this.controller?.abort(); this.controller = new AbortController(); this.content.replaceChildren(); this.status.hidden = false;
    showMessage(this.status, 'Загрузка материалов…');
    try {
      const data = await getHomeContent({ signal: this.controller.signal }); if (this.disposed) return;
      this.status.hidden = true; this.articleSection('Избранные статьи', data.featuredArticles || []);
      this.articleSection('Свежие статьи', data.articles || []); this.programSection(data.programs || []); this.photoSection(data.photos || []);
      if (!this.content.children.length) showMessage(this.content, 'Опубликованных материалов пока нет.');
    } catch (error) {
      if (this.controller.signal.aborted || this.disposed) return; showMessage(this.status, error.message, () => this.load());
    }
  }
  section(title, action, route) {
    const section = element('section', 'home-section'), header = element('div', 'home-section-header');
    header.append(element('h2', 'home-section-title', title)); const all = element('button', 'read-btn', action); all.type = 'button';
    all.addEventListener('click', () => this.onNavigate(route)); header.append(all); section.append(header); this.content.append(section); return section;
  }
  articleSection(title, posts) {
    if (!posts.length) return; const section = this.section(title, 'Все статьи →', 'blog'), grid = element('div', 'home-article-grid');
    for (const post of posts) {
      const card = element('button', 'home-article-card'); card.type = 'button'; card.setAttribute('aria-label', `Открыть раздел статей: ${post.title}`);
      card.append(element('span', 'home-card-meta', `${post.category?.name || 'Статья'} · ${formatDate(post.publishedAt)} · ${post.readTimeMinutes} мин`),
        element('h3', 'home-card-title', post.title), element('p', 'home-card-summary', post.summary), element('span', 'read-btn', 'Читать →'));
      card.addEventListener('click', () => this.onNavigate('blog')); grid.append(card);
    } section.append(grid);
  }
  programSection(programs) {
    if (!programs.length) return; const section = this.section('Избранные программы', 'Весь каталог →', 'files'), grid = element('div', 'home-program-grid');
    for (const program of programs.slice(0, 10)) {
      const card = element('button', 'home-program-card'); card.type = 'button';
      if (program.coverUrl) { const image = element('img', 'home-program-cover'); image.src = program.coverUrl; image.alt = program.coverAlt || ''; image.loading = 'lazy'; card.append(image); }
      const body = element('span', 'home-program-body'); body.append(element('strong', 'home-card-title', program.title),
        element('span', 'home-card-summary', program.summary || program.description || 'Описание готовится.'),
        element('span', 'home-card-meta', (program.platforms || []).join(' · ') || 'Программа'));
      card.append(body); card.addEventListener('click', () => this.onNavigate('files', program.section?.slug || '')); grid.append(card);
    } section.append(grid);
  }
  photoSection(photos) {
    if (!photos.length) return; const section = this.section('Избранное из галереи', 'Вся галерея →', 'gallery'), grid = element('div', 'home-photo-grid');
    for (const photo of photos) {
      const card = element('button', 'home-photo-card'); card.type = 'button'; card.setAttribute('aria-label', `Открыть галерею: ${photo.title}`);
      const image = element('img', 'home-photo-image'); image.src = photo.previewUrl; image.alt = photo.altText || photo.title; image.loading = 'lazy';
      card.append(image, element('span', 'home-photo-title', photo.title)); card.addEventListener('click', () => this.onNavigate('gallery', photo.section?.slug || '')); grid.append(card);
    } section.append(grid);
  }
  dispose() { this.disposed = true; this.controller?.abort(); }
}
